import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { acceptedFileTypes } from 'app-models';
import { ImmigrationWizardService } from '../services/immigration-wizard.service';
import { UploadDocumentService } from '../../../services/upload-document.service';
import { take, takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ToastrService } from 'ngx-toastr';
import { ImmigrationDocumentUploadService } from './immigration-document-upload.service';
import { environment } from 'src/environments/environment';
import { APIBeneficiaryDocuments } from 'base-beneficiary-documents-library';
import { sync_beneficiary_document_code } from 'permission-library';
import { ConfirmationModalComponent } from 'dirty-check-store';
import { MatDialog } from '@angular/material/dialog';
import { CustomErrorToastComponent } from 'custom-error-toast';

@Component({
  selector: 'app-immigration-document-upload',
  templateUrl: './immigration-document-upload.component.html',
  styleUrls: ['./immigration-document-upload.component.scss']
})
export class ImmigrationDocumentUploadComponent implements OnInit {
  buttonOnlyMode: boolean;
  documentTypeRequired: boolean;
  documentTypes = [];
  fileCategory = '';
  otherName = '';
  selectedDocType = '';
  acceptFileType: string;
  observableSubscription$ = new Subject();
  dependentIdSubscription: Subscription;
  beneficiaryId: number;
  onlyFormBuilder;
  familyId: any;
  viewMode = false;
  documentFileUploadConfigurations = {
    inputMultipleFlag: true,
    fileType: acceptedFileTypes,
    isFileListRequired: true,
    categoryName: 'OCRDOCTYPE',
    entityId: 1,
    fileCategory: '',
    listUploadedFiles: [],
    documentTypeRequired: true,
    docummentTypeCode: 'OCRDOCTYPE',
    useCase: 'beneficiary',
    useCaseId: 0,
    useEntityId: false,
    isDeleteEnabled: true,
    isUploadEnabled: true,
    isDownloadEnabled: false,
    familyId: null,
    family: false
  };
  documentType: string;
  uploadedFilesData: any;
  formDetails: any;
  @Output() formDetailsChange = new EventEmitter<any>();
  originalDocumentType: any;
  @Input() primaryData?: any;
  envPath: string;

  constructor(
    private uploadDocumentService: UploadDocumentService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private immigrationWizardService: ImmigrationWizardService,
    private authenticationService: AuthenticationService,
    private immigrationDocumentUploadService: ImmigrationDocumentUploadService,
    private aPIBeneficiaryDocuments: APIBeneficiaryDocuments,
    public dialog: MatDialog
  ) {
    this.envPath = environment.docs;
    // this.documentTypeRequired = false;
    // this.acceptFileType = acceptedFileTypes;
    this.onlyFormBuilder = this.route.snapshot.queryParams.pageFrom;
    if (this.onlyFormBuilder === 'FB') {
      this.beneficiaryId = (sessionStorage.getItem('FbEmployeeId')) ? parseInt(sessionStorage.getItem('FbEmployeeId')) : 0;
    } else {
      this.beneficiaryId = (sessionStorage.getItem('beneficiaryId')) ? parseInt(sessionStorage.getItem('beneficiaryId')) : (this.authenticationService.currentUserValue['beneficiaryId'] ? this.authenticationService.currentUserValue['beneficiaryId'] : sessionStorage.getItem('beneficiaryId'));
    }
  }

  ngOnInit(): void {
    if (this.beneficiaryId) {
      //this.documentFileUploadConfigurations.familyId = this.familyId;
      this.documentFileUploadConfigurations = Object.assign({}, {
        ...this.documentFileUploadConfigurations,
        useCaseId: this.beneficiaryId,
        entityId: this.beneficiaryId
      });
      this.getUpolodedFiles();
    }
  }
  onFilesDataChange(data: FormData) {
    this.uploadedFilesData = data;
    if(this.primaryData){
      this.aPIBeneficiaryDocuments.syncProfileData(
        this.primaryData.visatype,
        this.primaryData.caseType,
        this.primaryData.caseId,
        sync_beneficiary_document_code.SYNC_TASK_TYPE_BENE_IMMIGRATION,
        sync_beneficiary_document_code.SYNC_TASK_TYPE_BENE_IMMIGRATION_Code,
        this.primaryData.superTaskId,
        this.primaryData.subTaskId)
        .pipe(take(1))
        .subscribe();
    }    
    this.getUpolodedFiles();
  }

  onFileCategoryChange(category: any) {
    this.originalDocumentType = category;
    if (this.originalDocumentType == "OCRPASSPORT") {
      this.documentType = "PASSPORT"
    } else if (this.originalDocumentType == "OCRRESUME") {
      this.documentType = "RESUME"
    }
  }

  convertUpload(uploadedFilesData) {
    // const uploadedFilesData = this.documentFileUploadConfigurations.listUploadedFiles.reduce((prev, current) => {
    //   return (prev.id > current.id) ? prev : current;
    // });

    const docPath = uploadedFilesData.fileLocation.substring(23);
    const fileUrl = `${this.envPath}${docPath}`;
    this.immigrationDocumentUploadService.fetchFile(fileUrl)
      .pipe(take(1))
      .subscribe((blob: any) => {
        const file = new File([blob], fileUrl.split('/').pop(), { type: blob.type });
        const uploadedFormData: FormData = new FormData();
        uploadedFormData.append('file', file);
        let documentType;
        if (['PASSCOPY', 'OCRPASSPORT'].includes(uploadedFilesData.fileCategory.code)) {
          documentType = 'PASSPORT'
        } else if (['OCRRESUME','RESUME'].includes(uploadedFilesData.fileCategory.code)) {
          documentType = 'RESUME'
        }
        if (documentType) {
          this.immigrationWizardService.convertUploadDocument(
            documentType, this.beneficiaryId, uploadedFormData)
            .pipe(take(1))
            .subscribe((response: any) => {
              if (response.status === 200 && response.data?.data) {
                this.formDetails = response.data
                this.toastr.success(response.message, 'Success');
                this.formDetailsChange.emit({formDetails: this.formDetails, documentType: documentType});
                // this.uploadDocumentService.setFormDetails(this.formDetails);
              }
            });
        }
      });
  }
  getUpolodedFiles() {
    this.uploadDocumentService.genericGetUploadDocument(this.documentFileUploadConfigurations.useCase, this.documentFileUploadConfigurations.useCaseId, this.documentFileUploadConfigurations.categoryName, this.documentFileUploadConfigurations.entityId, this.documentFileUploadConfigurations.useEntityId, this.documentFileUploadConfigurations.familyId).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
      if (response['status'] === 200) {
        this.documentFileUploadConfigurations.listUploadedFiles = response['data'];
        this.documentFileUploadConfigurations = Object.assign({}, this.documentFileUploadConfigurations);
      } else {
        this.documentFileUploadConfigurations.listUploadedFiles = [];
        this.documentFileUploadConfigurations = Object.assign({}, this.documentFileUploadConfigurations);
      }
      if (response['status'] === 200 || response['status'] === 204) {
        //this.getDegreeDetails();
      }
    });
  }

  openDoc(item) {
    const docPath = item.fileLocation.substring(23);
    window.open(`${this.envPath}${docPath}`, '_blank');
  }

  dialogueInitializer(title: string, message: string) {
    // const cordinates: MouseEventInit = event;
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      width: '400px',
      data: {
        update: { title, message },
        buttons: ['Cancel', 'Delete']
      }
    });
    return dialogRef;
  }

  deleteFiles(item) {
    const title = 'Confirm';
    const message = 'Do you wish to Delete the File?';
    this.dialogueInitializer(title, message).afterClosed().subscribe(result => {
      if (result) {
        this.uploadDocumentService.genericDeleteUploadDocument(
          this.documentFileUploadConfigurations.useCase, this.documentFileUploadConfigurations.useCaseId, item.fileCategory.group, item.fileCategory.code,
          item.id, this.documentFileUploadConfigurations.entityId, this.documentFileUploadConfigurations.useEntityId, false)
          .pipe(take(1))
          .subscribe((response: any) => {
            if (response.status === 200) {
              this.toastr.success(response.message, 'Success');
              this.getUpolodedFiles();
            } else {
              CustomErrorToastComponent.showErrorToast(this.toastr, response.message);
            }
          });
      }
    });
  }
}
